import { useState } from 'react'

import { AppBar, Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

import { TabPanel, TasksAndHistory } from 'components/common'
import { useHashToSelectTab } from 'helpers'
import { PermissionType, Restricted, useIsAllowedTo } from 'providers'

import { AvailableLoads } from './AvailableLoads'
import { BookingsTracking } from './BookingsTracking'
import { DriversTracking } from './DriversTracking'
import { TaskBoard } from './TaskBoard'

enum TabId {
  Tasks = 0,
  TaskBoard = 1,
  BookingsTracking = 2,
  DriversTracking = 3,
  AvailableLoads = 4,
}
const tabsList = [
  {
    id: TabId.Tasks,
    label: 'Tasks',
    hash: '#dashboard-tasks',
    policy: 'ViewTaskDetailsDashboard' as PermissionType,
  },
  {
    id: TabId.TaskBoard,
    label: 'Board',
    hash: '#dashboard-task-board',
    policy: 'ViewTaskDetailsDashboard' as PermissionType,
  },
  {
    id: TabId.BookingsTracking,
    label: 'Bookings Tracking',
    hash: '#dashboard-bookings-tracking',
    policy: 'ViewBookingsTrackingDashboard' as PermissionType,
  },
  {
    id: TabId.DriversTracking,
    label: 'Drivers Tracking',
    hash: '#dashboard-drivers-tracking',
    policy: 'ViewDriverTrackingDashboard' as PermissionType,
  },
  {
    id: TabId.AvailableLoads,
    label: 'Available Loads',
    hash: '#dashboard-available-loads',
    policy: 'ViewAvailableLoadsDashboard' as PermissionType,
  },
]

function commonProps(index: any) {
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  }
}

const Dashboard = () => {
  const [tabValue, setTabValue] = useState<number | false>(false)

  const isAllowedTo = useIsAllowedTo()

  const filteredTabs = tabsList.filter((tab) => !tab.policy || isAllowedTo(tab.policy))

  useHashToSelectTab(filteredTabs, setTabValue)

  const renderTabs = () =>
    filteredTabs.map((tab) => (
      <Tab
        value={tab.id}
        label={tab.label}
        key={tab.id}
        {...commonProps(tab.id)}
        component={Link}
        to={{ hash: tab.hash }}
      />
    ))

  return (
    <div>
      <AppBar position='static' color='default'>
        <Tabs
          value={tabValue}
          aria-label='dashboard tabs'
          variant='scrollable'
          TabIndicatorProps={{ style: { transition: 'none' } }}>
          {renderTabs()}
        </Tabs>
      </AppBar>

      <Restricted to='ViewTaskDetailsDashboard'>
        <TabPanel value={tabValue} index={TabId.Tasks}>
          <TasksAndHistory bookingId={null} />
        </TabPanel>

        <TabPanel value={tabValue} index={TabId.TaskBoard}>
          <TaskBoard />
        </TabPanel>
      </Restricted>

      <Restricted to='ViewBookingsTrackingDashboard'>
        <TabPanel value={tabValue} index={TabId.BookingsTracking}>
          <BookingsTracking />
        </TabPanel>
      </Restricted>

      <Restricted to='ViewDriverTrackingDashboard'>
        <TabPanel value={tabValue} index={TabId.DriversTracking}>
          <DriversTracking />
        </TabPanel>
      </Restricted>

      <Restricted to='ViewAvailableLoadsDashboard'>
        <TabPanel value={tabValue} index={TabId.AvailableLoads}>
          <AvailableLoads />
        </TabPanel>
      </Restricted>
    </div>
  )
}

export default Dashboard
